import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AtgHomepageMyOrdersComponent } from './atg-homepage-my-orders/atg-homepage-my-orders.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';

@NgModule({
  declarations: [AtgHomepageMyOrdersComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    I18nModule,
  ],
    providers: [
      provideConfig({
        cmsComponents: {
          AtgHomepageFlexComponent: {
            component: () => import('./atg-homepage-my-orders/atg-homepage-my-orders.component').then((c) => c.AtgHomepageMyOrdersComponent),
      
          },
        },
      } as CmsConfig),
    ],  
  exports: [AtgHomepageMyOrdersComponent]
})
export class AtgHomepageMyOrdersModule {}
